<template>
    <div>
        <v-row dense  v-for="item in items" :key="item.id">
            <v-col>
                <card-result :item="item" @callOpenCloseDialog="openCloseDialog" />
            </v-col>
        </v-row>

        <!-- Dialog  -->
        <v-dialog 
            class="d-print-none"
            v-if="item && item != ''"
            v-model="dialog" 
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-system-bar
                class="d-print-none"
                dark
                color="primary"
                height="10px"
            >    
            </v-system-bar>   
 
            <v-card>
                <v-card elevation="0">
                    <v-card-title :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-1 font-weight-medium d-print-none' : 'text-h5 d-print-none'">
                        <v-row dense>
                            <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <span v-if="item.codigo">
                                    Código {{item.codigo}} 
                                </span>
                            </v-col>  

                            <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="text-right">
                                <v-row dense class="text-right">
                                    <v-spacer></v-spacer>
                                    <v-col cols="auto">
                                        <v-btn icon @click="openCloseDialog()">
                                            <v-icon>mdi-close</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>               
                            </v-col>      
                        </v-row>
                    </v-card-title>
                </v-card>

                <v-divider class="d-print-none"></v-divider>

                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <!--property-show v-if="module == 'showitem' && item.id" :object="item" /-->
                        </v-col>  
                    </v-row>     
                </v-container>
            </v-card>   
        </v-dialog>
        <!-- End Dialog -->
    </div>
</template>


<script>
import CardResult from './CardResult.vue';

export default {
    components: {
        CardResult,
    },

    props: {
        items: {
            type: Array, // Adicione o tipo
            required: false, // Corrigido: "required" em vez de "require"
            default: () => [] // Adicione um valor padrão para arrays
        },
    },

    computed: {
        me () {
          return this.$store.state.auth.me
        },
    },    

    data () {
        return {
            item: {},
            dialog: false
        }
    },

    methods: {
        openCloseDialog(){
            this.dialog = !this.dialog;
        },

        showItem(item){
            this.item = {};
            this.$store.dispatch('loadFac', item.id) 
                        .then(response => {
                            this.item = response.data
                            this.dialog = true
                        });
            
            this.dialog = true;
        }

    }
}
</script>